globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalCreateComment = (function(superClass)
{
    utils.extend(ModalCreateComment, superClass);

    function ModalCreateComment($html) {
      return ModalCreateComment.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalCreateComment.prototype, {
      init: function() {
        autosize(this.$html.find('.elastic'));
        this.$html.find('.select-search').select2();

        ModalCreateComment.__super__.init.apply(this, arguments);
      },
      callbackSuccess: function(data) {
        if(data.response) {
          var $container = $('.' + data.commentable_type + '-comments'),
              $firstComment = $container.find('.media:first');

          if($firstComment.length) {
            $firstComment.before(data.html)
          } else {
            $container.find('.no-comments').hide()
                      .end()
                      .find('.media-list').append(data.html)
          }
        }

        ModalCreateComment.__super__.callbackSuccess.apply(this, arguments);
      }
    });

    return ModalCreateComment;
})(backoffice.ModalMain);
